<template lang="pug">
v-container(fluid)
  v-card(class="mb-5")
    v-form
      v-row(class="px-2")
        v-col(cols="12" md="3")
          v-text-field(
            v-model="npn"
            clearable
            label="Número predial o Número predial anterior"
            required)
        v-col
          v-btn(
            :disabled="loading"
            :loading="loading"
            color="green"
            small
            class="ma-2 white--text"
            @click="search")
            v-icon(left dark) mdi-magnify
            | consultar
          v-btn(
            :disabled="loading"
            :loading="loading"
            color="red"
            small
            class="ma-2 white--text"
            @click="clear")
            v-icon(left dark) mdi-broom
            | limpiar
  v-row(dense)
    v-col(
      v-for="base in cadastralBases"
      :key="base.codigo"
      cols="4" md="4" sm="12" xs="12")
      cadastral-validity(
        :cadastral-base="base"
      )
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import CadastralValidity from '@/components/cadastral/CadastralValidity.vue';

export default {
  name: 'CadastralComparisonManager',

  components: {
    CadastralValidity,
  },

  props: {},

  emits: [],

  data() {
    return {
      // propiedad que indica que el componente esta cargando
      loading: false,
      // propieda que al macena el npn actual o anterior
      npn: '',
    };
  },

  computed: {
    ...mapState('cadastral', ['cadastralBases']),
  },

  async mounted() {
    if ('code' in this.$route.query) {
      // Inicializar el numero de matricula inmobiliaria
      let { code } = this.$route.query;
      if (code === undefined) {
        code = '';
      }
      this.npn = code;
      // ejecutar la funcion de consulta
      setTimeout(() => this.search(), 1000);
      // eliminar el parametro de la ruta
      window.history.replaceState({}, document.title, "/" + "cadastral_comparison");
    }
    // llenar bases de datos catastrales
    await this.getCadastralBases();
    // Obtener los dominios catastrales
    await this.getCadastralDomains();
  },

  methods: {
    ...mapMutations('cadastral', ['CHANGE_VALUE']),
    ...mapMutations('ui', ['SHOW_ALERT']),
    ...mapActions('cadastral', [
      'getCadastralBases',
      'cadastralBasesSearch',
      'getCadastralDomains',
    ]),
    // metodo que consulta la equivalencia de los poligonos catastrales
    async search() {
      if (this.npn === '') {
        alert('Debe ingresar un valor.');
        return;
      }
      this.loading = true;
      try {
        await this.cadastralBasesSearch({
          npn: this.npn,
        });
      } catch (error) {
        this.SHOW_ALERT({
          alertMessage:'Ocurrio un error al cargar la información',
          alertType: 'error'
        });
      }  
      this.loading = false;
    },
    // metodo para limpiar la vista
    clear() {
      this.npn = '';
      this.CHANGE_VALUE({
        value: null,
        varName: 'cadastralBasesSearchResult'
      });
    }
  }
};
</script>

<style scoped>
</style>
